// Import the Deadline type for type safety
import type { Deadline } from "../../../types";

// Props interface for the component
interface DeadlinesSectionProps {
  deadlines: Deadline[]; // Array of upcoming deadlines to display
}
// DeadlinesSection component
function DeadlinesSection({ deadlines }: DeadlinesSectionProps) {
  return (
  <section className="mb-16">
    {/* Section title */}
    <h2 className="text-3xl font-bold text-gray-900 mb-6 tracking-tight">
      Upcoming Deadlines
    </h2>

    {deadlines.length ? (
      <div className="space-y-4">
        {deadlines.map((deadline) => (
          <div
            key={deadline.id}
            className="bg-white p-6 rounded-xl shadow-sm flex justify-between items-center transition hover:shadow-md"
          >
            <p className="text-gray-800 font-medium text-lg">{deadline.title}</p>
            <p className="text-gray-500 text-sm">
              Due:{" "}
              {new Date(deadline.due_date).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </p>
          </div>
        ))}
      </div>
    ) : (
      <div className="bg-white p-6 rounded-xl shadow-sm text-center">
        <p className="text-gray-500">No upcoming deadlines.</p>
      </div>
    )}
  </section>
);

}
export default DeadlinesSection;
